module.exports = __webpack_public_path__ + "img/vrch-s-kapuci_81_temne-modra.47123df7.png";